<div
	class="image-asset-list-item"
	(click)="onImageClick($event)"
	[ngClass]="{ selected: selected }"
>
	<div
		*ngIf="deleteImageEnabled"
		class="delete-asset-btn"
		(click)="onDeleteAsset($event)"
	>
		<nb-icon icon="trash-outline"></nb-icon>
	</div>
	<div
		class="image-item"
		[ngStyle]="{
			backgroundImage: 'url(' + imageAsset.url + ')'
		}"
	></div>
</div>
